import {GraphQLClient} from 'graphql-request';
import {getSdk} from '../types/generated';

const clientGraphql = new GraphQLClient(process.env.REACT_APP_ENDPOINT + '/graphql');

export const SetClientJwt = (jwt => clientGraphql.setHeader("authorization", jwt));
const GraphqlClient = getSdk(clientGraphql);

export default GraphqlClient;
